import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { User, Users, Briefcase, Zap, Shield, Rocket } from 'lucide-react';

export default function PricingIndividual() {
  return (
    <SubpageTemplate 
      title="Individual Plan"
      subtitle="The Solo Pilot"
      description="Perfect for solo founders and experimental builders. Get all the core synthesis power without the enterprise overhead."
      icon={User}
      features={[
        {
          title: "Full Synthesis",
          description: "Access to the core build engine for unlimited project architectures.",
          icon: Zap
        },
        {
          title: "Community Support",
          description: "Join our discord of experimental builders to share tips and blueprints.",
          icon: Users
        },
        {
          title: "Basic Kinetics",
          description: "Standard edge deployment for up to 3 live projects simultaneously.",
          icon: Rocket
        }
      ]}
    />
  );
}
